import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { StoresContext } from '@App/contexts'
import ConfirmedNewUser from '@Components/AddNewUserSub/ConfirmedNewUserStep'
import AddNewUserStep from '@Components/AddNewUserSub/AddNewUserStep'

export interface IMyUserGroups {
    name: string
    checked: boolean
    disabled: boolean
}

const AddNewUserSub = () => {
    const { rightsholderUserStore } = React.useContext(StoresContext)
    const [formType, setFormType] = React.useState<'ADD' | 'CONFIRMED'>('ADD')

    const destroyForm = () => {
        rightsholderUserStore.destroyRightsHolderInviteInfo()
        setFormType('ADD')
    }

    const changeFormTo = (type: 'ADD' | 'CONFIRMED') => {
        setFormType(type)
    }

    useEffect(
        () => () => {
            rightsholderUserStore.destroyRightsHolderInviteInfo()
        },
        []
    )

    if (formType === 'ADD') {
        return <AddNewUserStep changeFormTo={changeFormTo} />
    } else if (formType === 'CONFIRMED') {
        return <ConfirmedNewUser destroyForm={destroyForm} />
    } else {
        return null
    }
}

export default observer(AddNewUserSub)
